import axios from 'axios'

export const fetchContactInfo = async () => {
  const response = await axios.get('contact')
  return response.data.data
}

export const updateContactInfo = async (payload) => {
  const response = await axios.put('contact', payload)
  return response.data.data
}

